<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5 class="title t-apply"></h5>
                    <div class="msg-view">
                        <div class="text">确认{{ type == 1 ? '同意' : '拒绝' }}<b>【{{ player_data }}】</b>的申请！</div> 
                        <div class="tips">队员加入后仅可退队1次</div>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    position: relative;
    width: 650px;
    height: 404px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);  
}

.t-apply{
    width: 255px;
    height: 39px;
    margin: 0 auto 32px;
    background-image: url(~@/assets/images/modal/title-apply.png);      
}

.msg-view{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    height: 120px;
    text-align: center;
    margin: 0 auto 0;
    padding: 0 20px;

    color: #daefff;
    line-height: 1.8;

    b{
        padding: 0 10px;
        // color: #d16443;
    }
}

.warn{
    font-size: 20px;
    text-align: center;
    color: #725132;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 0 20px;
}

.u-btn.ok{
    width: 279px;
    height: 87px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 279px;
    height: 87px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiApplyAgree } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码 
            id : 0,
            type : 1, 
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },      
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiApplyAgree({ id : this.id , review : this.type, }).then(
                res => {
                    this.destroyElement();
                    this.$toast('成功~');
                    this.$team_update();
                    this.$update_evt();
                },
                rej => {
                    //this.$toast(rej.message);
                    //let msg = rej.code == 1011 ? '' : rej.message;
                    this.destroyElement();
                    this.$msg_modal({type : 'error-apply' ,text : rej.message});
                },
            )
        },                
    },
}
</script>